import { render, staticRenderFns } from "./InfoCollection.vue?vue&type=template&id=7ea95476&scoped=true&"
import script from "./InfoCollection.vue?vue&type=script&lang=js&"
export * from "./InfoCollection.vue?vue&type=script&lang=js&"
import style0 from "./InfoCollection.vue?vue&type=style&index=0&id=7ea95476&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea95476",
  null
  
)

export default component.exports